import { type AuthUser } from "wasp/auth";
import DefaultLayout from "../layout/DefaultLayout";
import { useRedirectHomeUnlessUserIsAdmin } from "../useRedirectHomeUnlessUserIsAdmin";
import { useEffect } from "react";
import setDocumentTitle from "../../setDocumentTitle";
import EnrichmentConfigView from "../../views/EnrichmentConfigView/EnrichmentConfigView";

const AdminEnrichmentConfigPage = ({ user }: { user: AuthUser }) => {
  useRedirectHomeUnlessUserIsAdmin({ user });
  useEffect(() => {
    setDocumentTitle("Enrichment");
  }, [])


  return (
    <DefaultLayout user={user}>
      <EnrichmentConfigView/>
    </DefaultLayout>
  );
};

export default AdminEnrichmentConfigPage;
